import { format } from '@react-input/mask';

export const PHONE_MASK_OPTIONS = {
  mask: '+7 (___) ___-__-__',
  replacement: { _: /\d/ },
} as const;

function getPhoneDigits(value: string): string {
  const digits = value.replace(/\D/g, '');

  if (!digits) {
    return '';
  }

  if ((digits.startsWith('7') || digits.startsWith('8')) && digits.length <= 11) {
    return digits.slice(1, 11);
  }

  return digits.slice(0, 10);
}

export function formatPhoneValue(value?: string | null): string {
  const digits = getPhoneDigits(value ?? '');
  return digits ? format(digits, PHONE_MASK_OPTIONS) : '';
}
